const validateParams = params => params.forEach(({ name, type, value, optional }) => {
    if (optional) return;

    const to = typeof value;
    if (to !== type) {
        throw new Error(`Invalid parameter "${name}" must be of type "${type}", but got "${to}"`);
    }
});

export default validateParams;
